export function calculatePercent(min, max, value) {
    if (value > max) {
        return 1;
    }
    else if (value < min) {
        return 0;
    }
    else {
        return (value - min) / (max - min);
    }
}
export function degreesToRadians(degrees) {
    return degrees * (Math.PI / 180);
}
